/**
 * Controls the behaviour of RosenheimJetztOpenStreetMapMarkers
 * has to be on first level of window cause of the HOOK!!
 * @type {Window.RosenheimJetztOpenStreetMapMarkers}
 */
window.RosenheimJetztOpenStreetMapMarkers = function (geojsonLayer) {
	/**
	 * set icon by theme
	 * @param theme
	 * @returns {*}
	 */
	let getIconByTheme = function (theme) {
		let iconUrl = '/_Resources/Static/Packages/RosenheimJetzt.OpenStreetMap/Images/Markers/' + theme + '.png'
		let myIcon = L.icon({
			iconUrl: iconUrl,
			iconSize: [71, 'auto'],
			iconAnchor: [25, 70],
			popupAnchor: [15, -70],
			tooltipAnchor: [25, -35],
			className: 'map-marker',
		})
		return myIcon
	}

	// get the data of the generated markers
	const markers = geojsonLayer._layers

	if (typeof markers === 'object') {
		let geoJsonObjects = []

		Object.keys(markers).forEach((key, index) => {
			geoJsonObjects.push({
				type: 'Feature',
				properties: markers[key].feature.properties,
				geometry: markers[key].feature.geometry,
			})
		})

		return L.geoJSON(geoJsonObjects, {
			pointToLayer: function (geoJsonPoint, latlng) {
				let marker = L.marker(latlng, { icon: getIconByTheme(geoJsonPoint.properties.theme) })
				if (geoJsonPoint.properties.popup) {
					marker.bindPopup(geoJsonPoint.properties.popup)
				}
				if (geoJsonPoint.properties.tooltip) {
					marker.bindTooltip(geoJsonPoint.properties.tooltip)
				}
				return marker
			},
		})
	}

	// if markers are not an object return null!
	return null
}
